<ng-container *transloco="let convert;">
  <div [ngClass]="tenantClass$ | async" #accordionWrapper>
    <h2 data-test-id="user-contact-page-heading" tabindex="-1" class="focus-outline-none" #pageHeading>
    {{convert('profileManagement.userContact.textContactInfo')}}</h2>
    @if (showError) {
      <error-message data-test-id="user-contact-error-message" aria-live="assertive"></error-message>
    }
    <div class="contact-info">
      <div class="contact-section d-flex flex-column flex-md-row">
        <div class="info-section p-3">
          <p data-test-id="user-contact-email-label" class="info-label">{{convert('profileManagement.userContact.textEmail')}}</p>
          <p data-test-id="user-contact-email-value" class="info-content">{{ emailAddress }}</p>
          <button data-test-id="user-contact-email-edit-button" data-track-elem="button" data-track-name="Edit" class="btn btn-link p-0 edit-btn position-relative"
            (click)="onEditEmail()" [attr.aria-label]="convert('profileManagement.userContact.ariaLabelEditEmail')">
            {{convert('profileManagement.userContact.btnEdit')}}
            <ng-container *ngTemplateOutlet="tmplIndicatorEmail"></ng-container>
          </button>
        </div>
        <div [style.order]="editModeMobilePhone ? null : 3" class="info-section p-3">
          <p data-test-id="user-contact-mobile-label" class="info-label" [attr.aria-label]="convert('profileManagement.userContact.textEnterMobile')">
          {{convert('profileManagement.userContact.textMobile')}} </p>
          <p data-test-id="user-contact-mobile-value" class="info-content">{{ phoneNumber | mobilePhone }}</p>

          @if (phoneNumber) {
            <button data-test-id="user-contact-mobile-edit-button" data-track-elem="button" data-track-name="Edit" class="btn btn-link p-0 edit-btn position-relative"
              (click)="onEditMobilePhone()"
              [attr.aria-label]="convert('profileManagement.userContact.ariaLabelEditMobile')">
              {{convert('profileManagement.userContact.btnEdit')}}
              <ng-container *ngTemplateOutlet="tmplIndicatorPhone"></ng-container>
            </button>
            @if (featureMobileNotif) {
              <strong> | </strong>
            }
            @if (featureMobileNotif) {
              <button data-test-id="user-contact-mobile-remove-button" data-track-elem="button" data-track-name="Remove"
                class="btn btn-link p-0 edit-btn" (click)="onRemoveMobilePhoneClicked()"
                [attr.aria-label]="convert('profileManagement.userContact.ariaLabelRemoveMobile')">
                {{convert('profileManagement.userContact.btnRemove')}}
              </button>
            }
          }
          @if (!phoneNumber) {
            <button data-test-id="user-contact-mobile-add-button" data-track-elem="button" data-track-name="Add" class="btn btn-link p-0 edit-btn position-relative"
              (click)="onEditMobilePhone()"
              [attr.aria-label]="convert('profileManagement.userContact.ariaLabelAddMobile')">
              {{convert('profileManagement.userContact.btnAdd')}}
              <ng-container *ngTemplateOutlet="tmplIndicatorPhone"></ng-container>
            </button>
          }
        </div>
        <!-- Personal Info Drawer: Mobile -->
        @if (isMobile) {
          <div class="d-md-none">
            <ng-container *ngTemplateOutlet="personalInfoDrawer"></ng-container>
          </div>
        }
      </div>

      <!-- Personal Info Drawer: Desktop -->
      @if (!isMobile) {
        <div  class="d-none d-sm-block">
          <ng-container *ngTemplateOutlet="personalInfoDrawer"></ng-container>
        </div>
      }
    </div>
    @if (showSuccess) {
      <div class="personal-info-success-message">
        @if (isManageAlertsEnabled) {
          <p><success-message data-test-id="user-contact-success-message-with-link" aria-live="assertive" [message]="message"
            [goToLink]="convert('profileManagement.userContact.linkAlert')"
          (click)="isAlertsPageEnabled() ? navigateTo('/profile-management/manage-alerts/alerts') : showBuyandSell()"></success-message></p>
        }
        @if (!isManageAlertsEnabled) {
          <p><success-message data-test-id="user-contact-success-message" aria-live="assertive" [message]="message"></success-message></p>
        }
      </div>
    }
    @if (shouldDisplayAlertNotice()) {
      <div class="alert-i-bubble d-flex flex-column flex-md-row">
        <div class="alert-text">
          <p><i class="allycon-info-outline text-primary"></i> {{convert('profileManagement.profileMobile.moveAlerts')}}
          <a data-test-id="user-contact-alert-notice-manage-alerts-link" class="profile-nav__link"
            href="javascript:void(0);" (click)="navigateTo('/profile-management/manage-alerts/alerts')"
            [ngClass]="activeChildRoute == '/profile-management/manage-alerts/alerts' ? activeClass : null"
            [attr.aria-label]="convert('profileManagement.profileNav.ariaLabelManageAlert')">
            {{convert('profileManagement.profileNav.alerts')}}
          </a>
          <button
            data-test-id="user-contact-alert-notice-close-button"
            class="close"
            aria-label="Close"
            (click)="close()">
            <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
          </button>
        </p>
      </div>
    </div>
  }

  @if (!isAlertsPageEnabled() && isManageAlertsEnabled) {
    <div>
      <h2 data-test-id="user-contact-alerts-heading" tabindex="-1" class="focus-outline-none" id="alerts-header">
      {{convert('profileManagement.userContact.textMyAlert')}}</h2>
      <p data-test-id="user-contact-alerts-description">{{convert('profileManagement.userContact.textSelectAlert')}}</p>
      <accordion class="pb-0 alert-settings">
        @if (buyAlerts$) {
          <accordion-group data-test-id="user-contact-buy-accordion" panelClass="buy-accordion" class="child-accordion" [isOpen]="buyIsOpen"
            (isOpenChange)="isOpenChange($event, 'buy')" #buyAccordion>
            <div data-test-id="user-contact-buy-accordion-toggle" tabindex="0" class="btn btn-link btn-block clearfix alert-settings__toggle" accordion-heading
              (click)="toggleBuyAccordion()" (keydown.enter)="toggleBuyAccordion()" data-track-elem="accordion" data-track-name="Buy"
              data-track-trigger="statechange" [attr.data-track-state]="buyIsOpen ? 'opened' : 'closed'"
              [attr.aria-label]="buyIsOpen ? convert('profileManagement.userContact.ariaLabelBuyExpanded') : convert('profileManagement.userContact.ariaLabelBuyCollapsed')">
              <i class="allycon-glyph-caret-right" aria-hidden="true"></i> <span
            class="d-inline-block ms-1">{{convert('profileManagement.userContact.textBuy')}}</span>
          </div>
          @if (showBuyError) {
            <error-message data-test-id="user-contact-buy-error-message" id="buy-error-message" tabindex="-1"></error-message>
          }
          @if (showBuySuccess) {
            <success-message data-test-id="user-contact-buy-success-message" message="{{convert('profileManagement.userContact.textSuccessfullyBuyAlert')}}"
            id="buy-success-message" tabindex="-1"></success-message>
          }
          @if (requireMobileConsent) {
            <p data-test-id="app-user-contact-e-buyer-add-edit-mobile-number-notifications-link">{{addOrEditText}} <a class="edit-phone-link" (click)="onEditMobilePhone()">{{userContactTranslations.textMobileNumber}}</a>{{userContactTranslations.textOptIn}}</p>
          }
          @if (buyIsOpen) {
            <table data-test-id="user-contact-buy-table" class="alert-settings__table" id="buy_table" tabIndex="-1">
              <caption class="d-none">
                {{convert('profileManagement.userContact.textBuyAlerts')}}
              </caption>
              <colgroup>
              <col class="alert-settings__setting-value" />
              <col />
            </colgroup>
            @if (!inServiceVehiclesEnabled && buyAlerts$ | async; as buyAlerts) {
              @if (hasAlertType(buyAlerts, 'Text')) {
                <thead>
                  <tr>
                    <th scope="col">{{convert('profileManagement.userContact.text')}}</th>
                    <th class="alerts-label" scope="col">{{convert('profileManagement.userContact.textSendAlert')}}</th>
                  </tr>
                </thead>
              }
              <tbody>
                @for (alert of buyAlerts; track alert; let i = $index) {
                  <tr [ngClass]="{ 'd-none': !checkVisibility(alert) }"
                    [attr.aria-hidden]="!buyIsOpen && !checkVisibility(alert)">
                    @if (alert.sendType === 'Text') {
                      <td>
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input form-control" [id]="alert.type"
                            [attr.data-test-id]="'user-contact-buy-text-checkbox-' + i"
                            (change)="updateNotificationBuy($event, alert)" [checked]="checked(alert.type)"
                            attr.aria-label="{{ convert('notifications.'+alert.type) }}" [attr.aria-hidden]="!buyIsOpen"
                            [disabled]="requireMobileConsent" />
                          <label [for]="alert.type" class="custom-control-label"
                            [attr.aria-hidden]="!buyIsOpen && !checkVisibility(alert)">
                          </label>
                        </div>
                      </td>
                      <td class="alert-settings__options">{{ convert("notifications."+alert.type) }}</td>
                    }
                  </tr>
                }
              </tbody>
            }
            @if (buyAlerts$ | async; as buyAlerts) {
              @if (hasAlertType(buyAlerts, 'Email')) {
                <thead>
                  <tr>
                    <th scope="col">{{convert('profileManagement.userContact.labelEmail')}}</th>
                    <th  class="alerts-label" scope="col">{{convert('profileManagement.userContact.textSendAlert')}}</th>
                  </tr>
                </thead>
              }
              <tbody>
                @for (alert of buyAlerts; track alert; let i = $index) {
                  <tr [ngClass]="{ 'd-none': !checkVisibility(alert) }"
                    [attr.aria-hidden]="!buyIsOpen && !checkVisibility(alert)">
                    @if (alert.sendType === 'Email') {
                      <td>
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input form-control" [id]="alert.type"
                            [attr.data-test-id]="'user-contact-buy-email-checkbox-' + i"
                            (change)="updateNotificationBuy($event, alert)" [checked]="checked(alert.type)"
                            attr.aria-label="{{ convert('notifications.'+alert.type) }}" [attr.aria-hidden]="!buyIsOpen"
                            [disabled]="isSavedSearchSummaryAlert(alert) && !hasSavedSearches" />
                          <label [for]="alert.type" class="custom-control-label"
                            [attr.aria-hidden]="!buyIsOpen && !checkVisibility(alert)">
                          </label>
                        </div>
                      </td>
                      <td class="alert-settings__options">{{ convert("notifications."+alert.type) }}
                        @if (isSavedSearchSummaryAlert(alert)) {
                        <app-saved-search-summary-dropdown data-test-id="alerts-buy-saved-search-summary-dropdown"
                          [disabled]="!checked(alert.type)" [selected]="selectedSavedSearchIds"
                          (selectedChange)="selectedSavedSearchIds = $event"
                          (hasSavedSearchesChange)="hasSavedSearches = $event">
                        </app-saved-search-summary-dropdown>
                        }
                      </td>
                    }
                  </tr>
                }
              </tbody>
            }
          </table>
        }
        @if (buyIsOpen) {
          <div class="d-flex flex-column flex-md-row alert-settings__actions">
            <button data-test-id="user-contact-buy-save-button" data-track-elem="button" data-track-name="Save" class="btn btn-primary me-md-2 mb-2 mb-md-0"
              type="button" (click)="saveBuyNotifs()" [attr.aria-hidden]="!buyIsOpen">
              {{convert('common.btnSave')}}
            </button>
            <button data-test-id="user-contact-buy-cancel-button" data-track-elem="button" data-track-name="Cancel" class="btn btn-link bid-buttons" type="button"
              (click)="cancelBuy()" [attr.aria-hidden]="!buyIsOpen">
              {{convert('common.btnCancel')}}
            </button>
          </div>
        }
      </accordion-group>
    }
    @if (showSellerAlerts) {
      @if (sellAlerts$) {
        <accordion-group data-test-id="user-contact-sell-accordion" panelClass="sell-accordion" class="child-accordion" [isOpen]="sellIsOpen"
          (isOpenChange)="isOpenChange($event, 'sell')" #sellAccordion>
          <div data-test-id="user-contact-sell-accordion-toggle" tabindex="0" class="btn btn-link btn-block clearfix alert-settings__toggle" accordion-heading
            (click)="toggleSellAccordion()" (keydown.enter)="toggleSellAccordion()" data-track-elem="accordion" data-track-name="Sell"
            data-track-trigger="statechange" [attr.data-track-state]="sellIsOpen ? 'opened' : 'closed'"
            [attr.aria-label]="sellIsOpen ? convert('profileManagement.userContact.ariaLabelSellExpanded') : convert('profileManagement.userContact.ariaLabelSellCollapsed')">
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
            <span class="d-inline-block ms-1">{{convert('profileManagement.userContact.textSell')}}</span>
          </div>
          @if (showSellError) {
            <error-message data-test-id="user-contact-sell-error-message" id="sell-error-message" tabindex="-1"></error-message>
          }
          @if (showSellSuccess) {
            <success-message data-test-id="user-contact-sell-success-message" message="{{convert('profileManagement.userContact.textSuccessfullySellAlert')}}"
            id="sell-success-message" tabindex="-1"></success-message>
          }
          @if (requireMobileConsent) {
            <p data-test-id="app-user-contact-e-seller-add-edit-mobile-number-notifications-link">{{addOrEditText}} <a class="edit-phone-link" (click)="onEditMobilePhone()">{{userContactTranslations.textMobileNumber}}</a>{{userContactTranslations.textOptIn}}</p>
          }
          @if (sellIsOpen) {
            <table data-test-id="user-contact-sell-table" class="alert-settings__table" id="sell_table" tabIndex="-1" [attr.aria-hidden]="!sellIsOpen"
              >
              <caption class="d-none">
                {{convert('profileManagement.userContact.textSellAlerts')}}
              </caption>
              <colgroup>
              <col class="alert-settings__setting-value" />
              <col />
            </colgroup>
            @if (sellAlerts$ | async; as sellAlerts) {
              @if (hasAlertType(sellAlerts, 'Text')) {
                <thead>
                  <tr>
                    <th scope="col">{{convert('profileManagement.userContact.text')}}</th>
                    <th class="alerts-label" scope="col">{{convert('profileManagement.userContact.textSendAlert')}}</th>
                  </tr>
                </thead>
              }
              <tbody>
                @for (alert of sellAlerts; track alert; let i = $index) {
                  <tr [ngClass]="{ 'd-none': !checkVisibility(alert) }">
                    @if (alert.sendType === 'Text') {
                      <td>
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input form-control" [id]="alert.type"
                            [attr.data-test-id]="'user-contact-sell-text-checkbox-' + i"
                            (change)="updateNotificationSell($event, alert)" [checked]="checked(alert.type)"
                            attr.aria-label="{{ convert('notifications.'+alert.type) }}" [attr.aria-hidden]="!sellIsOpen"
                            [disabled]="requireMobileConsent" />
                          <label [for]="alert.type" class="custom-control-label"> </label>
                        </div>
                      </td>
                      <td class="alert-settings__options">{{ convert("notifications."+alert.type) }}</td>
                    }
                  </tr>
                }
              </tbody>
            }
            @if (sellAlerts$ | async; as sellAlerts) {
              @if (hasAlertType(sellAlerts, 'Email')) {
                <thead>
                  <tr>
                    <th scope="col">{{convert('profileManagement.userContact.labelEmail')}}</th>
                    <th class="alerts-label" scope="col">{{convert('profileManagement.userContact.textSendAlert')}}</th>
                  </tr>
                </thead>
              }
              <tbody>
                @for (alert of sellAlerts; track alert; let i = $index) {
                  <tr [ngClass]="{ 'd-none': !checkVisibility(alert) }">
                    @if (alert.sendType === 'Email') {
                      <td>
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input form-control" [id]="alert.type"
                            [attr.data-test-id]="'user-contact-sell-email-checkbox-' + i"
                            (change)="updateNotificationSell($event, alert)" [checked]="checked(alert.type)"
                            attr.aria-label="{{ convert('notifications.'+alert.type) }}"
                            [attr.aria-hidden]="!sellIsOpen" />
                          <label [for]="alert.type" class="custom-control-label"> </label>
                        </div>
                      </td>
                      <td class="alert-settings__options">{{ convert("notifications."+alert.type) }}</td>
                    }
                  </tr>
                }
              </tbody>
            }
          </table>
        }
        @if (sellIsOpen) {
          <div class="d-flex flex-column flex-md-row alert-settings__actions">
            <button data-test-id="user-contact-sell-save-button" data-track-elem="button" data-track-name="Save" class="btn btn-primary me-md-2 mb-2 mb-md-0"
              type="button" (click)="saveSellNotifs()" [attr.aria-hidden]="!sellIsOpen">
              {{convert('common.btnSave')}}
            </button>
            <button data-test-id="user-contact-sell-cancel-button" data-track-elem="button" data-track-name="Cancel" class="btn btn-link bid-buttons" type="button"
              (click)="cancelSell()" [attr.aria-hidden]="!sellIsOpen">
              {{convert('common.btnCancel')}}
            </button>
          </div>
        }
      </accordion-group>
    }
  }
</accordion>
</div>
}
<!-- Template: Personal Info Drawer -->
<ng-template #personalInfoDrawer>
  <section class="ui-drawer" [ngClass]="{ 'is-open': isDrawerOpen }">
    <button data-test-id="user-contact-drawer-close-button" data-track-elem="icon" data-track-name="Close" data-track-trigger="close" class="drawer__close"
      [attr.aria-label]="convert('common.btnClose')" (click)="cancelCurrentDrawer()">
      <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
    </button>
    @if (editModeEmail) {
      <ng-container *ngTemplateOutlet="tmplFormEmail"></ng-container>
    }

    @if (editModeMobilePhone) {
      <ng-container *ngTemplateOutlet="tmplFormPhone"></ng-container>
    }
  </section>
</ng-template>
<!-- Template: Form Email -->
<ng-template #tmplFormEmail>
  <form data-test-id="user-contact-email-form" class="form" [formGroup]="contactForm" (ngSubmit)="saveEmail()">
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-7">
        <label data-test-id="user-contact-email-form-label" class="info-label" for="email">{{userContactTranslations.textEditEmail}}</label>
        <app-email-input
          data-test-id="user-contact-email-input"
          [inputForm]="contactForm"
          [emailInputConfig]="emailInputConfig"
          [translations]="userContactTranslations"
          [invalidFormatEmail]="invalidFormatEmail"
          [emailContainsSpecialChars]="emailContainsSpecialChars">
        </app-email-input>
      </div>
    </div>
  </form>

  <div class="action-btns">
    <button data-test-id="user-contact-email-save-button" data-track-elem="button" data-track-name="Save" class="btn btn-primary bid-buttons me-2"
      (click)="saveEmail()">
      {{convert('profileManagement.userContact.btnSaveChanges')}}
    </button>
    <button data-test-id="user-contact-email-cancel-button" data-track-elem="button" data-track-name="Cancel" class="btn btn-link bid-buttons"
      (click)="cancelEmail()">
      {{convert('common.btnCancel')}}
    </button>
  </div>
</ng-template>
<!-- Template: Form Mobile Phone -->
<ng-template #tmplFormPhone>
  <form data-test-id="user-contact-phone-form" class="form" [formGroup]="contactForm" (ngSubmit)="saveMobilePhone()">
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-4">
        <label data-test-id="user-contact-phone-label" class="info-label" for="phone">{{ phoneNumber ? convert('profileManagement.userContact.btnEdit') :
          convert('profileManagement.userContact.btnAdd') }}
        {{convert('profileManagement.userContact.textMobile')}}</label>
        <div class="input-wrapper">
          <span class="input-label">{{convert('profileManagement.userContact.textMobile')}}</span>
          <input data-test-id="user-contact-phone-input" #controlPersonalInfo class="input form-control" type="text" id="phone" mask="000-000-0000"
            formControlName="phoneNumber"
            [class.is-invalid]="contactForm?.invalid && contactForm?.controls?.phoneNumber?.errors || !isPhoneFormValid"
            aria-required="true" />
          @if (contactForm?.invalid && contactForm?.controls?.phoneNumber?.errors || !isPhoneFormValid) {
            <div
              data-test-id="user-contact-phone-invalid-feedback"
              class="invalid-feedback wider-feedback" aria-live="assertive">
              {{convert('profileManagement.userContact.textEnterValidPhone')}}
            </div>
          }
          <div aria-live="assertive" class="mt-4 mb-2 providing-mobile"
            [innerHTML]="convert('profileManagement.userContact.textProvidingMobile')">
          </div>
        </div>
      </div>
    </div>
    @if (featureMobileNotif) {
      <div class="row mt-3">
        <div class="col-12">
          <div class="input-wrapper">
            <p>{{convert('profileManagement.userContact.textSelectBox')}}</p>
            <div class="custom-control custom-checkbox w-100">
              <input data-test-id="user-contact-phone-consent-checkbox" type="checkbox" class="custom-control-input" id="control-consent" formControlName="mobileConsent"
                [checked]="contactForm.controls.mobileConsent.value">
              <label data-test-id="user-contact-phone-consent-label" class="custom-control-label ms-2" for="control-consent">
                <strong>{{convert('profileManagement.userContact.textReceiveText')}}</strong>
              </label>
            </div>
            <p class="quick-note">
              <br />
              <strong>{{convert('profileManagement.userContact.textQuickNote')}}</strong><br />
              <span
              [innerHTML]="convert('profileManagement.userContact.textOpting', {mobileNotifTenantText : mobileNotifTenantText, buyerShortCode : buyerShortCode, sellerShortCode : sellerShortCode})"></span>
              <strong>
                <a data-test-id="user-contact-phone-terms-link" href="{{ setTermsAndConditionsLink() }}" target="_blank" allytmln="Terms and Conditions"
                rel="noopener noreferrer">{{convert('profileManagement.userContact.textTermCondition')}}</a>
              </strong>
              @if (privacyURL && !allyPrivacyLinkEnabled) {
                {{convert('profileManagement.userContact.textOur')}}
                <strong>
                  <a data-test-id="user-contact-phone-privacy-link" routerLink="/privacy/FULL" target="_blank"
                  rel="noopener noreferrer">{{convert('profileManagement.userContact.textPrivacyPolicy')}}</a>
                </strong>
              }
              @if (allyPrivacyLinkEnabled) {
                {{convert('profileManagement.userContact.textOur')}}
                <strong>
                  <a data-test-id="user-contact-phone-privacy-link" routerLink="/privacy/FULL">{{convert('profileManagement.userContact.textPrivacyPolicy')}}</a>
                </strong>
                }.
              </p>
              {{convert('profileManagement.userContact.textManage')}}
              <strong>
                <a data-test-id="user-contact-phone-notification-link" tabindex="0" class="text-primary"
                (click)="showBuyAndSellOptions()">{{convert('profileManagement.userContact.textNotification')}}</a></strong>.
              </div>
            </div>
          </div>
        }
      </form>
      <div class="action-btns">
        <button data-test-id="user-contact-phone-save-button" data-track-elem="button" data-track-name="Save" id="btnPhoneSave" class="btn btn-primary bid-buttons me-2"
          (click)="saveMobilePhone()">
          {{convert('profileManagement.userContact.btnSaveChanges')}}
        </button>
        <button data-test-id="user-contact-phone-cancel-button" data-track-elem="button" data-track-name="Cancel" class="btn btn-link bid-buttons"
          (click)="cancelMobilePhone()">
          {{convert('common.btnCancel')}}
        </button>
      </div>
    </ng-template>
    <!-- Template: Drawer Indicator -->
    <ng-template #tmplIndicatorEmail>
      @if (editModeEmail) {
        <ng-container *ngTemplateOutlet="tmplDrawerIndicator"></ng-container>
      }
    </ng-template>
    <ng-template #tmplIndicatorPhone>
      @if (editModeMobilePhone) {
        <ng-container *ngTemplateOutlet="tmplDrawerIndicator"></ng-container>
      }
    </ng-template>
    <!-- Template: Drawer Indicator -->
    <ng-template #tmplDrawerIndicator>
      <div class="triangle">
        <div class="tg-border"></div>
        <div class="tg-overlay"></div>
      </div>
    </ng-template>
    <app-save-changes-modal data-test-id="user-contact-save-changes-modal" (cancelEditing)="cancelEditing()" (continueEditing)="continueEditing()" [modalId]="modalId">
    </app-save-changes-modal>
    <app-remove-mobile-phone-modal data-test-id="user-contact-remove-mobile-phone-modal" (removed)="removeMobilePhoneConfirmed()"></app-remove-mobile-phone-modal>
    <app-revoke-text-message-consent-modal data-test-id="user-contact-revoke-consent-modal"
    (revoked)="saveMobilePhoneRevokeConfirmed()"></app-revoke-text-message-consent-modal>
    <app-sms-modal data-test-id="user-contact-sms-modal" [tenantUuid]="tenantUuid" [userId]="getUserId()" [mobilePhone]="getMobilePhone()"
    (mobileVerified)="advanceAfterSmsModal($event)"></app-sms-modal>
  </div>
</ng-container>
